import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../claimCheckPageStyle.js";

const useStyles = makeStyles(styles);

export default function DirectiveSection({ t }) {
  const classes = useStyles();
  return (
    <div className={classes.directiveSection}>
      <div className={classes.directiveInner}>
        <div className={classes.directiveIcon}>EU</div>
        <div>
          <h2 className={classes.directiveTitle}>{t.directiveTitle}</h2>
          <p className={classes.directiveText}>{t.directiveText}</p>
          <div className={classes.badges}>
            <span className={classes.badge}>&#10003; {t.badgeIndependent}</span>
            <span className={classes.badge}>&#10003; {t.badgeIso}</span>
            <span className={classes.badge}>&#10003; {t.badgeTransparent}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
